import { Tooltip as MuiTooltip, useTheme } from "@mui/material";
import { Group } from "@visx/group";
import { scaleOrdinal } from "@visx/scale";
import { Text } from "@visx/text";
import { useState } from "react";

const VisxHorizontalDistributionChart = (props: any) => {
  const {
    data: rawData,
    width,
    height,
    colors,
    defaultPrimaryText,
    defaultSecondaryText,
  } = props;

  const [active, setActive] = useState<any>(null);
  const [tooltipPos, setTooltipPos] = useState<{ x: number; y: number } | null>(null);
  const theme = useTheme();

  const data = [...rawData].sort((a, b) => b.value - a.value);
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const barHeight = 30;
  const xMax = width;

  const colorScale = scaleOrdinal({
    range: colors, // lighter with alpha
    domain: data.map((d: any) => d.label),
  });

  let offset = 0;

  return (
    <svg
      width={width}
      height={height}
      onMouseLeave={() => {
        setActive(null);
        setTooltipPos(null);
      }}
    >
      <Group top={5} left={0}>
        {data.map((d: any, i: number) => {
          const segmentWidth = (d.value / total) * xMax;
          const x = offset;
          offset += segmentWidth;

          const isActive = active?.label === d.label;

          return (
            <MuiTooltip
              key={`tooltip-${i}`}
              open={isActive}
              title={`${d.label}: ${d.value}`}
              placement="top"
              arrow
            >
              <Group
                key={`segment-${i}`}
                onMouseEnter={e => {
                  setActive(d);
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                }}
                onMouseMove={e => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                }}
                onClick={() => d.onClick?.()}
                className={d.onClick ? "hand" : ""}
              >
                <rect
                  x={x}
                  y={0}
                  width={segmentWidth}
                  height={barHeight}
                  fill={colorScale(d.label)?.toString()}
                  stroke={theme.palette.divider}
                  strokeWidth={1}
                  opacity={isActive ? 1 : 0.8}
                />
                {segmentWidth > 40 && (
                  <Text
                    x={x + segmentWidth / 2}
                    y={barHeight / 2}
                    dy="0.33em"
                    textAnchor="middle"
                    fontSize={12}
                    fontWeight={500}
                    fill={"#000"}
                  >
                    {d.label?.split(" ").map((e: string) => e[0]?.toUpperCase()).join("")}
                  </Text>
                )}
              </Group>
            </MuiTooltip>
          );
        })}

        {/* Summary text below the bar */}
        {!active ? (
          <Text
            x={0}
            y={barHeight + 20}
            fontSize={18}
            fontWeight={500}
            fill={theme.palette.text.primary}
          >
            {defaultPrimaryText + "  " + defaultSecondaryText}
          </Text>
        ) : (
          <Text
            x={0}
            y={barHeight + 20}
            fontSize={18}
            fontWeight={500}
            fill={theme.palette.text.primary}
          >
            {(active.valueLabel || active.value) + "  " + active.label}
          </Text>
        )}
      </Group>
    </svg>
  );
};

export default VisxHorizontalDistributionChart;